export const SET_PAYMENT_SUMMARY = 'SetPaymentSummary';
export const SET_REPAIR_ORDER_ID = 'SetRepairOrderId';
export const SET_REPAIR_ORDER_CUSTOMER = 'SetRepairOrderCustomer';
